(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-cart-extras"] && !Shopify.designMode) return;
  try {
    (function () {
    // Add a variant to the cart and let Horizon redraw the drawer or the cart page.
    function lpuAdd(variantId, button, message, okText) {
      button.disabled = true;
      function fail() { message.textContent = 'Please try again'; button.disabled = false; }
      var actions = window.Shopify && window.Shopify.actions;
      if (actions && actions.updateCart) {
        actions.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: 1 }] })
          .then(function (result) {
            if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
            message.textContent = okText;
          })
          .catch(fail);
      } else {
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error(); window.location.reload(); })
          .catch(fail);
      }
    }

    if (!customElements.get('lpu-free-shipping')) {
      class LpuFreeShipping extends HTMLElement {
        static get observedAttributes() { return ['data-cents']; }
        connectedCallback() { this.check(); }
        attributeChangedCallback() { if (this.isConnected) this.check(); }
        check() {
          var cents = parseInt(this.dataset.cents, 10) || 0;
          var threshold = parseInt(this.dataset.threshold, 10) || 10000;
          var complete = cents >= threshold;
          // Confetti the first time free shipping shows on this page, and any time the cart crosses the line.
          if (complete && window.__lpuWasComplete !== true) this.burst();
          window.__lpuWasComplete = complete;
        }
        burst() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          var self = this;
          setTimeout(function () {
            var bar = self.isConnected ? self.querySelector('.lpu-fs__bar') : document.querySelector('.lpu-fs__bar');
            var r = bar ? bar.getBoundingClientRect() : null;
            if (!r || r.width === 0) return;
            // On phones Horizon opens the drawer with showModal(), which puts it in the browser's
            // top layer, above anything in the page. The confetti goes inside it to be seen.
            var dialog = bar.closest('dialog');
            var modal = false;
            try { modal = !!(dialog && dialog.open && dialog.matches(':modal')); } catch (e) { modal = !!(dialog && dialog.open); }
            var layer = document.createElement('div');
            layer.className = 'lpu-confetti-layer';
            (modal ? dialog : document.body).appendChild(layer);
            var origin = layer.getBoundingClientRect();
            var x = r.left + r.width / 2 - origin.left, y = r.top + r.height / 2 - origin.top;
            var colors = ['#E61755', '#B00020', '#FFC857', '#3DDC97', '#4D96FF', '#FF7EB6'];
            var fall = Math.max(260, window.innerHeight - (r.top + r.height / 2) + 40);
            var spread = Math.min(r.width + 40, 420) / 2;
            for (var i = 0; i < 60; i++) {
              var piece = document.createElement('span');
              piece.className = 'lpu-fs__piece';
              piece.style.left = (x + Math.random() * 40 - 20).toFixed(0) + 'px';
              piece.style.top = y.toFixed(0) + 'px';
              piece.style.background = colors[Math.floor(Math.random() * colors.length)];
              piece.style.setProperty('--dx', (Math.random() * spread * 2 - spread).toFixed(0) + 'px');
              piece.style.setProperty('--up', (-80 - Math.random() * 120).toFixed(0) + 'px');
              piece.style.setProperty('--dy', (fall * (0.6 + Math.random() * 0.4)).toFixed(0) + 'px');
              piece.style.setProperty('--rot', (Math.random() * 900 - 450).toFixed(0) + 'deg');
              piece.style.animationDelay = (Math.random() * 0.3).toFixed(2) + 's';
              layer.appendChild(piece);
            }
            setTimeout(function () { layer.remove(); }, 4200);
          }, 650);
        }
      }
      customElements.define('lpu-free-shipping', LpuFreeShipping);
    }

    // Horizon redraws the drawer by changing the boxes in place instead of replacing them, so
    // nothing below remembers state from setup. Every tap reads the page as it is right now.

    // Bag step: pick a color, add.
    if (!customElements.get('lpu-bag-upsell')) {
      class LpuBagUpsell extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          var self = this;
          this.addEventListener('click', function (e) {
            var s = e.target.closest('[data-swatch]');
            if (s && self.contains(s)) { self.pick(s); return; }
            var add = e.target.closest('[data-add]');
            if (add && self.contains(add)) {
              var on = self.querySelector('[data-swatch][aria-checked="true"]');
              lpuAdd(on ? on.dataset.swatch : self.dataset.variantId, add, self.querySelector('[data-message]'), 'Added to cart');
            }
          });
        }
        pick(s) {
          var price = this.querySelector('[data-price]');
          var image = this.querySelector('[data-bag-img]');
          if (price) price.textContent = s.dataset.price;
          if (image && s.dataset.image) { image.src = s.dataset.image; image.alt = s.dataset.alt || image.alt; }
          this.querySelectorAll('[data-swatch]').forEach(function (i) { i.setAttribute('aria-checked', i === s ? 'true' : 'false'); });
          var add = this.querySelector('[data-add]');
          if (add) add.disabled = false;
        }
      }
      customElements.define('lpu-bag-upsell', LpuBagUpsell);
    }

    // Tee and hoodie step: pick a design, pick a size, add.
    // The design buttons come from the server, one per product in stock.
    if (!customElements.get('lpu-multi-upsell')) {
      class LpuMultiUpsell extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          var self = this;
          this.addEventListener('click', function (e) {
            var d = e.target.closest('[data-design]');
            if (d && self.contains(d)) { self.show(Number(d.dataset.design)); return; }
            var add = e.target.closest('[data-add]');
            if (add && self.contains(add)) {
              var select = self.querySelector('[data-size-select]');
              if (select && select.value) lpuAdd(select.value, add, self.querySelector('[data-message]'), 'Added to cart');
            }
          });
          this.addEventListener('change', function (e) {
            if (e.target.matches && e.target.matches('[data-size-select]')) self.syncVariant();
          });
        }
        products() {
          var node = this.querySelector('[data-products]');
          try { return JSON.parse(node ? node.textContent : '[]'); } catch (e) { return []; }
        }
        current() {
          var on = this.querySelector('[data-design][aria-checked="true"]');
          return on ? Number(on.dataset.design) : 0;
        }
        show(i) {
          var p = this.products()[i];
          var select = this.querySelector('[data-size-select]');
          if (!p || !select) return;
          var keep = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : (this.dataset.size || '');
          this.querySelectorAll('[data-design]').forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.design) === i ? 'true' : 'false'); });
          var title = this.querySelector('[data-title]');
          if (title) title.textContent = p.title;
          var html = '';
          var picked = false;
          p.variants.forEach(function (v) {
            if (!v.a) return;
            var sel = !picked && v.s === keep;
            if (sel) picked = true;
            html += '<option value="' + v.id + '"' + (sel ? ' selected' : '') + '>' + String(v.s).replace(/</g, '&lt;') + '</option>';
          });
          select.innerHTML = html;
          this.syncVariant();
          var msg = this.querySelector('[data-message]');
          if (msg) msg.textContent = '';
          var add = this.querySelector('[data-add]');
          if (add) add.disabled = !select.value;
        }
        syncVariant() {
          var p = this.products()[this.current()];
          var select = this.querySelector('[data-size-select]');
          var id = Number(select && select.value);
          var v = p && p.variants.filter(function (x) { return x.id === id; })[0];
          if (!v) return;
          var price = this.querySelector('[data-price]');
          var img = this.querySelector('[data-img]');
          if (price) price.textContent = v.price;
          if (img && v.img) { img.src = v.img; img.alt = p.title; }
        }
      }
      customElements.define('lpu-multi-upsell', LpuMultiUpsell);
    }

    // Love Pants carousel: tap a size to add that pair. The arrows (mouse only) scroll two cards.
    if (!customElements.get('lpu-pants')) {
      class LpuPants extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          var self = this;
          this.addEventListener('click', function (e) {
            var arrow = e.target.closest('[data-dir]');
            if (arrow && self.contains(arrow)) {
              var track = self.querySelector('[data-track]');
              var card = track && track.querySelector('li');
              var step = card ? card.getBoundingClientRect().width + 10 : 150;
              if (track) track.scrollBy({ left: Number(arrow.dataset.dir) * step * 2, behavior: 'smooth' });
              return;
            }
            var add = e.target.closest('[data-pants-add]');
            if (add && self.contains(add) && !add.disabled) {
              lpuAdd(add.dataset.pantsAdd, add, self.querySelector('[data-message]'), 'Added ' + add.dataset.label);
            }
          });
        }
      }
      customElements.define('lpu-pants', LpuPants);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
